/* eslint-disable eqeqeq */
function validaData(valorData) {

    var dia = valorData.split("/")[0];
    var mes = valorData.split("/")[1];
    var ano = valorData.split("/")[2];
    var MyData = new Date(ano, mes - 1, dia);
    if ((MyData.getMonth() + 1 != mes)
        || (MyData.getDate() != dia)
        || (MyData.getFullYear() != ano))
        return false
    else
        return true;

}

export default validaData;